




























































import { ScheduleType, CampaignFormData, AdgroupConfig, CreateMode } from '@tt4b/ttam-enums';
import { useAdgroupBudgetValidate } from '@tt4b/ttam-hooks';
import { defineComponent, computed, toRefs, ref } from '@vue/composition-api';
import TtamScheduleStartTimeDatePicker from '../starttime-datepicker/index.vue';
import { PropType } from 'vue';

const name = 'ttam-schedule-date-duration-timepicker';

export default defineComponent({
  name,
  components: {
    TtamScheduleStartTimeDatePicker,
  },
  props: {
    startTime: {
      type: String,
      default: '',
    },
    duration: {
      type: Number,
      default: 0,
    },
    startTimeDisabled: {
      type: Boolean,
      default: false,
    },
    durationTimeDisabled: {
      type: Boolean,
      default: false,
    },
    timezone: {
      type: String,
      default: 'Asia/Shanghai',
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
      required: true,
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
      required: true,
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    getAccountNowTimestamp: {
      type: Function,
      default: () => () => 0,
    },
    timezoneOffset: {
      type: Number,
      default: 0,
    },
    bottomShortcutsOptions: {
      type: Object,
      default: () => ({}),
    },
    disableScrollControl: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupConfig, createMode, getAccountNowTimestamp } = toRefs(props);
    const startTimeRef = ref();
    const durationRef = ref();
    const hoursDurationInput = ref();
    const minDurationInput = ref();
    const { timeRangeValidator, durationValidator } = useAdgroupBudgetValidate({
      campaignFormData: campaignData,
      adgroupEditConfig: adgroupConfig,
      getAccountNowTimestamp,
      createMode,
    });

    const _scheduleStartTime = computed({
      get: () => props.startTime || '',
      set: v => {
        emit('start-time-change', v);
      },
    });
    const _scheduleDuration = computed({
      get: () => (isNaN(props.duration) ? 0 : props.duration),
      set: v => {
        emit('duration-change', v);
        durationRef.value.validate && durationRef.value.validate('change');
      },
    });

    const _scheduleHoursDuration = computed(() => {
      const hours = Math.floor(Number(_scheduleDuration.value) / 60);
      return hours;
    });
    // duration存储单位为min，需要转换成hours + min的形式
    const _scheduleMinDuration = computed(() => {
      const minDuration = Number(_scheduleDuration.value % 60);
      return minDuration;
    });
    const handleChangeHours = v => {
      const hours = isNaN(parseInt(v)) ? 0 : parseInt(v);
      // 为了兼用hours输入 1.4的情况
      hoursDurationInput.value.setCurrentValue(hours);
      const scheduleDuration = Number(hours * 60 + _scheduleMinDuration.value);
      _scheduleDuration.value = scheduleDuration;
    };
    const handleChangeMin = v => {
      const min = isNaN(parseInt(v)) ? 0 : parseInt(v);
      const scheduleDuration = Number(_scheduleHoursDuration.value * 60 + min);
      const minDuration = Number(_scheduleDuration.value % 60);
      // 为了兼容min输入70的情况
      minDurationInput.value.setCurrentValue(minDuration);
      _scheduleDuration.value = scheduleDuration;
    };
    return {
      name,
      ScheduleType,
      startTimeRef,
      durationRef,
      hoursDurationInput,
      minDurationInput,
      _scheduleStartTime,
      _scheduleDuration,
      _scheduleMinDuration,
      _scheduleHoursDuration,
      timeRangeValidator,
      durationValidator,
      handleChangeHours,
      handleChangeMin,
    };
  },
});
